import { render, staticRenderFns } from "./DuplicateIconChecked.vue?vue&type=template&id=396b7832&scoped=true&"
import script from "./DuplicateIconChecked.vue?vue&type=script&lang=js&"
export * from "./DuplicateIconChecked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b7832",
  null
  
)

export default component.exports